function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _getPrototypeOf(o1) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o1);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o2, p1) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o2, p1);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
var __decorate = this && this.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import regeneratorRuntime from "regenerator-runtime";
import _get from "lodash/get";
import { Component, Vue } from "vue-property-decorator";
import { Action, State } from "vuex-class";
import ListItem from "./list-item.vue";
import { createTemplateSkin, deleteTemplateSkin, getTemplateSkinList, updateTemplateSkin } from "@/api/gmaker/template-skin";
var SkinList = /*#__PURE__*/ function(Vue1) {
    "use strict";
    _inherits(SkinList, Vue1);
    var _super = _createSuper(SkinList);
    function SkinList() {
        _classCallCheck(this, SkinList);
        var _this;
        _this = _super.apply(this, arguments);
        _this.loading = false;
        _this.skinList = [];
        _this.promptOptions = {
            confirmButtonText: "\u786E\u5B9A",
            cancelButtonText: "\u53D6\u6D88",
            inputPlaceholder: "\u76AE\u80A4\u540D\u79F0",
            inputValidator: function inputValidator(value) {
                if (!value) {
                    return "\u76AE\u80A4\u540D\u79F0\u4E0D\u80FD\u4E3A\u7A7A";
                } else if (value.length === 0) {
                    return "\u76AE\u80A4\u540D\u79F0\u4E0D\u80FD\u4E3A\u7A7A";
                } else if (!value.match("^[a-zA-Z0-9_\u4E00-\u9FA5]+$")) {
                    return "\u4E0D\u652F\u6301\u7279\u6B8A\u5B57\u7B26";
                } else if (value.length > 20) {
                    return "\u8BF7\u8F93\u516520\u4E2A\u5B57\u7B26\u4EE5\u5185\u7684\u76AE\u80A4\u540D\u79F0";
                }
                return true;
            }
        };
        return _this;
    }
    var _proto = SkinList.prototype;
    _proto.handleClose = function handleClose(tag) {
        var _this = this;
        return _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
            var index;
            return regeneratorRuntime.wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return _this.$confirm("\u786E\u8BA4\u5220\u9664\u8BE5\u76AE\u80A4\u3010".concat(tag.name, "\u3011\u5417\uFF1F"), "\u5220\u9664\u76AE\u80A4", _this.promptOptions);
                    case 3:
                        _ctx.next = 5;
                        return deleteTemplateSkin({
                            id: tag.id
                        });
                    case 5:
                        // 如果删除的是当前皮肤，需要跳转到默认皮肤
                        if (tag.id === _this.skinId) {
                            _this.jumpToNewSkin(_this.skinList[0].id);
                        } else {
                            index = _this.skinList.findIndex(function(item) {
                                return item.id === tag.id;
                            });
                            _this.skinList.splice(index, 1);
                        }
                        _ctx.next = 11;
                        break;
                    case 8:
                        _ctx.prev = 8;
                        _ctx.t0 = _ctx["catch"](0);
                        // 非 confirm cancel 的场景需要提示报错信息
                        if (_ctx.t0 !== "cancel") {
                            _this.$message.error(_ctx.t0.message || "\u5220\u9664\u76AE\u80A4\u63A5\u53E3\u5931\u8D25");
                        }
                    case 11:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    8
                ]
            ]);
        }))();
    };
    _proto.handleClick = function handleClick(tag) {
        var _this = this;
        return _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
            return regeneratorRuntime.wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return _this.$confirm("\u5207\u6362\u76AE\u80A4\u524D\u5C06\u4F1A\u81EA\u52A8\u4FDD\u5B58\u5F53\u524D\u914D\u7F6E\uFF0C\u786E\u8BA4\u4FDD\u5B58\u5F53\u524D\u914D\u7F6E\u5230\u76AE\u80A4\u3010".concat(_this.currentSkinName, "\u3011, \u5E76\u4E14\u5207\u6362\u5230\u76AE\u80A4\u3010").concat(tag.name, "\u3011\u5417\uFF1F"), "\u63D0\u793A", _this.promptOptions);
                    case 3:
                        _ctx.next = 5;
                        return _this.saveTemplateInfo();
                    case 5:
                        _this.jumpToNewSkin(tag.id);
                        _ctx.next = 11;
                        break;
                    case 8:
                        _ctx.prev = 8;
                        _ctx.t0 = _ctx["catch"](0);
                        // 非 confirm cancel 的场景需要提示报错信息
                        if (_ctx.t0 !== "cancel") {
                            _this.$message.error(_ctx.t0);
                        }
                    case 11:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    8
                ]
            ]);
        }))();
    };
    _proto.handleEdit = function handleEdit(tag) {
        var _this = this;
        return _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
            var inputData, newSkinName;
            return regeneratorRuntime.wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return _this.$prompt("\u4FEE\u6539\u76AE\u80A4\u540D\u79F0\uFF0C\u539F\u76AE\u80A4\u540D\u79F0\u3010".concat(tag.name, "\u3011"), "\u4FEE\u6539\u76AE\u80A4\u540D\u79F0", _this.promptOptions);
                    case 3:
                        inputData = _ctx.sent;
                        newSkinName = inputData.value;
                        _ctx.next = 7;
                        return updateTemplateSkin({
                            id: tag.id,
                            name: newSkinName
                        });
                    case 7:
                        _this.skinList.find(function(item) {
                            return item.id === tag.id;
                        }).name = newSkinName;
                        _ctx.next = 13;
                        break;
                    case 10:
                        _ctx.prev = 10;
                        _ctx.t0 = _ctx["catch"](0);
                        // 非 confirm cancel 的场景需要提示报错信息
                        if (_ctx.t0 !== "cancel") {
                            _this.$message.error(_ctx.t0.message || "\u7F16\u8F91\u76AE\u80A4\u63A5\u53E3\u5931\u8D25");
                        }
                    case 13:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    10
                ]
            ]);
        }))();
    };
    _proto.handleCreate = function handleCreate() {
        var _this = this;
        return _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
            var inputData;
            return regeneratorRuntime.wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return _this.$prompt("\u6DFB\u52A0\u76AE\u80A4\u524D\u5C06\u4F1A\u81EA\u52A8\u4FDD\u5B58\u5F53\u524D\u914D\u7F6E\uFF0C\u786E\u8BA4\u4FDD\u5B58\u5F53\u524D\u914D\u7F6E\u5230\u76AE\u80A4\u3010".concat(_this.currentSkinName, "\u3011, \u5E76\u4E14\u521B\u5EFA\u76AE\u80A4\u5417\uFF1F"), "\u63D0\u793A", _this.promptOptions);
                    case 3:
                        inputData = _ctx.sent;
                        _ctx.next = 6;
                        return _this.saveTemplateInfo();
                    case 6:
                        _ctx.next = 8;
                        return _this.createSkin(String(inputData.value));
                    case 8:
                        _ctx.next = 13;
                        break;
                    case 10:
                        _ctx.prev = 10;
                        _ctx.t0 = _ctx["catch"](0);
                        // 非 confirm cancel 的场景需要提示报错信息
                        if (_ctx.t0 !== "cancel") {
                            _this.$message.error(_ctx.t0);
                        }
                    case 13:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    10
                ]
            ]);
        }))();
    };
    _proto.getSkinListData = function getSkinListData() {
        var _this = this;
        return _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
            var res;
            return regeneratorRuntime.wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _this.loading = true;
                        _ctx.next = 4;
                        return getTemplateSkinList({
                            template_id: _this.templateId
                        });
                    case 4:
                        res = _ctx.sent;
                        _this.loading = false;
                        _this.skinList = _get(res, "data.data.list");
                        _ctx.next = 13;
                        break;
                    case 9:
                        _ctx.prev = 9;
                        _ctx.t0 = _ctx["catch"](0);
                        _this.loading = false;
                        _this.$message.error(_ctx.t0.message || "\u83B7\u53D6\u76AE\u80A4\u63A5\u53E3\u5931\u8D25");
                    case 13:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    9
                ]
            ]);
        }))();
    };
    _proto.createSkin = function createSkin(name) {
        var _this = this;
        return _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
            var res, skinId;
            return regeneratorRuntime.wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return createTemplateSkin({
                            template_id: _this.templateId,
                            name: name
                        });
                    case 3:
                        res = _ctx.sent;
                        skinId = _get(res, "data.data.skin_id");
                        _this.jumpToNewSkin(skinId);
                        _ctx.next = 11;
                        break;
                    case 8:
                        _ctx.prev = 8;
                        _ctx.t0 = _ctx["catch"](0);
                        _this.$message.error(_ctx.t0.message || "\u521B\u5EFA\u76AE\u80A4\u63A5\u53E3\u5931\u8D25");
                    case 11:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    8
                ]
            ]);
        }))();
    };
    _proto.checkIsActive = function checkIsActive(tag) {
        return this.skinId === tag.id;
    };
    _proto.jumpToNewSkin = function jumpToNewSkin(skinId) {
        this.$router.push({
            name: "creative.common-template",
            params: {
                templateId: String(this.templateId),
                skinId: String(skinId)
            }
        });
    };
    _proto.mounted = function mounted() {
        this.getSkinListData();
    };
    _createClass(SkinList, [
        {
            key: "currentSkinName",
            get: function get() {
                var _this = this;
                return this.skinList.find(function(item) {
                    return item.id === _this.skinId;
                }).name;
            }
        }
    ]);
    return SkinList;
}(Vue);
__decorate([
    Action("creative/template/saveTemplateInfo")
], SkinList.prototype, "saveTemplateInfo", void 0);
__decorate([
    State(function(state) {
        return state.creative.template.templateId;
    })
], SkinList.prototype, "templateId", void 0);
__decorate([
    State(function(state) {
        return state.creative.template.skinId;
    })
], SkinList.prototype, "skinId", void 0);
SkinList = __decorate([
    Component({
        components: {
            ListItem: ListItem
        }
    })
], SkinList);
export { SkinList as default };
